import { useState, useContext, useEffect } from 'react';
import { CoreContext } from '../context/index.js';
import { selectIsFulfilled } from '../storeSelectors/user.js';
import { isAuthenticated } from '../utils/auth.js';
import '../utils/cookies.js';
import 'cookies-next';
import '../cookies-VX_DpI1q.js';
import '../currency-_kacFJHO.js';
import '../language-BHHwgtQp.js';
import '../payment-a4IKjS7g.js';
import '../utils/isBot.js';

const useAuthenticated = () => {
    // Initially set loggedIn status by cookie token: isAuthenticated()
    // If token present - then assume that a user is loggedIn
    const [isLogged, setIsLogged] = useState(isAuthenticated());
    const { useSelector } = useContext(CoreContext);
    // Check if user auth verification request is fulfilled
    const isFulfilled = useSelector(selectIsFulfilled);
    useEffect(() => {
        if (!isFulfilled)
            return;
        // Update loggedIn status by cookie token after user auth verification request fulfilled
        // If token is invalid or expired, then it will be already removed from cookies and user is loggedOut
        setIsLogged(isAuthenticated());
    }, [isFulfilled]);
    return isLogged;
};

export { useAuthenticated as default };
//# sourceMappingURL=useAuthenticated.js.map
